module.exports = __webpack_public_path__ + "static/media/animated_logo.a633be2f.svg";